import Image from 'next/image';

import './CourseBundleCard.scss';
import IconOpenSlot from '@assets/images/courses/icon-open-slot.webp';
import IconLeerVanExperts from '@assets/images/courses/icon-leer-van-experts.webp';
import IconGeld from '@assets/images/courses/icon-geld.webp';
import IconZwangerschapscursussen from '@assets/images/courses/icon-zwangerschapscursussen-colored.webp';
import icons from '@assets/icons/redesign';
import LinkWithTracking from '../../LinkWithTracking/LinkWithTracking';

const { Checkmark } = icons;

export default function CourseBundleCard({
  imageSrc,
  imageAlt,
  title,
  description,
  features,
  priceOld,
  priceNew,
  buttonLabel,
  buttonLink,
  benefits,
  showInsuranceNote,
  trackingCategory,
  trackingAction,
  trackingName
}) {
  return (
    <section className="courseBundle">
      <div className="courseBundle-content">
        <CourseBundleCard.Details
          features={features}
          title={title}
          description={description}
          priceOld={priceOld}
          priceNew={priceNew}
          buttonLabel={buttonLabel}
          buttonLink={buttonLink}
          showInsuranceNote={showInsuranceNote}
          trackingCategory={trackingCategory}
          trackingAction={trackingAction}
          trackingName={trackingName}
        />
      </div>

      <Image
        src={imageSrc}
        alt={imageAlt}
        className="courseBundle-image"
        sizes="(min-width: 1200px) 60vw, 100vw"
        placeholder="blur"
      />

      <CourseBundleCard.Benefits benefits={benefits} />
    </section>
  );
}

CourseBundleCard.Details = ({
  features,
  title,
  description,
  priceOld,
  priceNew,
  buttonLabel,
  buttonLink,
  showInsuranceNote,
  trackingCategory,
  trackingAction,
  trackingName
}) => {
  return (
    <div className="courseBundle-card">
      <h2 className="courseBundle-title">{title}</h2>
      <p className="courseBundle-description">{description}</p>

      <ul className="courseBundle-list">
        {features.map((label, idx) => (
          <li key={idx} className="courseBundle-list-item">
            <Checkmark className="courseBundle-list-item-icon" /> {label}
          </li>
        ))}
      </ul>

      <div className="courseBundle-pricing">
        <span className="courseBundle-pricing-old">€{priceOld}</span>
        <span className="courseBundle-pricing-new">€{priceNew}</span>
      </div>

      <LinkWithTracking
        href={buttonLink}
        className="courseBundle-button"
        category={trackingCategory}
        action={trackingAction}
        name={trackingName}
      >
        {buttonLabel}
      </LinkWithTracking>

      {showInsuranceNote && (
        <a
          href="/verzekering/cursus-vergoeding"
          className="courseBundle-note"
          target="_blank"
        >
          *Check of jouw zorgverzekering onze cursussen vergoed &gt;
        </a>
      )}
    </div>
  );
};

CourseBundleCard.Benefits = ({ benefits }) => {
  const benefitList = [
    {
      icon: IconLeerVanExperts,
      description:
        'Icon van hersenen omdat je leert van experts tijdens de zwangerschapscursus'
    },
    {
      icon: IconOpenSlot,
      description: 'Icon van geopend slot'
    },
    {
      icon: IconGeld,
      description: 'Icon van losgeld'
    },
    {
      icon: IconZwangerschapscursussen,
      description: 'Icon van online zwangerschapscursus'
    }
  ];

  return (
    <div className="courseBundle-benefits">
      <h2 className="courseBundle-benefits-title">Wat je krijgt</h2>

      <ul className="courseBundle-benefits-list">
        {benefits.map((label, idx) => (
          <li className="courseBundle-benefits-list-item" key={idx}>
            <Image
              src={benefitList[idx].icon}
              className="courseBundle-benefits-list-item-icon"
              alt={benefitList[idx].description}
              sizes="(min-width: 768px) 110px, 63px"
            />
            <span className="courseBundle-benefits-list-item-label">
              {label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
